<template>
  <span>
    <employee-role :id="employee.id" :role.sync="employee.role" />
    <employee-category-tags
      :id="employee.id"
      :tags.sync="employee.tags"
      @refresh="refresh"
      category="department"
      :multiple="true"
      name="changeDepartments"
      :importSettings="true"
      :role="
        role('admin', 'departmentManager', 'manager', 'safetyRepresentative')
      "
    />

    <employee-positions
      :id="employee.id"
      :employeeTags="employee.tags"
      @refresh="refresh"
    />

    <employee-category-tags
      :id="employee.id"
      :tags.sync="employee.tags"
      @refresh="refresh"
      category="shift"
      :multiple="false"
      name="changeShift"
      :importSettings="false"
      :role="
        role('admin', 'departmentManager', 'manager', 'safetyRepresentative')
      "
    />

    <employee-category-tags
      :id="employee.id"
      :tags.sync="employee.tags"
      @refresh="refresh"
      category="collar"
      :multiple="true"
      name="changeCollar"
      :importSettings="false"
      :role="
        role('admin', 'departmentManager', 'manager', 'safetyRepresentative')
      "
    />

    <employee-deactivate
      v-if="employee.id != me.id"
      :employee="employee"
      @refresh="refresh"
    />
    <employee-modes
      :id="employee.id"
      :modes.sync="employee.modes"
      @refresh="refresh"
    />
    <change-manager
      :id="employee.id"
      :manager="employee.manager"
      @manager_changed="(m) => (employee.manager = m)"
    />
  </span>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import EmployeeCategoryTags from "@/components/EmployeeCategoryTags";
import EmployeeRole from "@/components/EmployeeRole";
import EmployeePositions from "@/components/EmployeePositions";
import EmployeeDeactivate from "@/components/control/EmployeeDeactivate";
import EmployeeModes from "@/components/EmployeeModes";
import ChangeManager from "@/components/control/ChangeManager.vue";

export default {
  components: {
    EmployeeCategoryTags,
    EmployeeRole,
    EmployeePositions,
    EmployeeDeactivate,
    EmployeeModes,
    ChangeManager,
  },
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["role"]),
    ...mapState(["me"]),
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
